import React from 'react'
import clsx from 'clsx'
import {
  Dialog,
  DialogContent,
  Typography,
  makeStyles,
  createStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import Slide from '@material-ui/core/Slide'
import { TransitionProps } from '@material-ui/core/transitions'
import CMSText from '../Global/CMSText'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    dialog: {},
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      textAlign: 'center',
      padding: theme.spacing(2, 6, 6, 6),
    },
    dialogHeader: {
      display: 'inline-flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: theme.palette.common.white,
    },
    cross: {
      cursor: 'pointer',
      height: 37,
      width: 37,
      padding: theme.spacing(0.5),
      color: theme.palette.common.white,
    },
    statesContainer: {},
    stateTitle: {
      paddingBottom: theme.spacing(1.25),
    },
    stateDescription: {},
    stateRefusedTitle: {
      borderTop: '1px solid black',
      paddingTop: theme.spacing(1.25),
    },
    stateRefusedDescription: {},
  })
)

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type Tprops = {
  open: any
  handleClose: () => void
  takeBackData: any
  entries: any
}

const StatesModal = ({ open, handleClose, takeBackData, entries }: Tprops) => {
  const modalClasses = useStyles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const { t } = useTranslation()

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className={clsx('takeBack-dialog__states', modalClasses.dialog)}
    >
      <DialogContent
        className={clsx(
          'takeBack-dialog__states__content',
          modalClasses.dialogContent
        )}
      >
        <div
          className={clsx('takeBack-dialog__header', modalClasses.dialogHeader)}
        >
          <Typography
            variant="h4"
            className="takeBack-dialog__header__close-text"
          >
            {t('texts:takeBack:close_modal')}
          </Typography>
          <CancelIcon
            onClick={handleClose}
            className={clsx(
              'takeBack-dialog__header__close-icon',
              modalClasses.cross
            )}
          />
        </div>
        {entries.map(([key, stateValue]) => {
          return (
            <div key={key} className={clsx(modalClasses.statesContainer)}>
              <Typography
                component="h2"
                variant="h3"
                className={clsx(modalClasses.stateTitle)}
              >
                {stateValue.title}
              </Typography>
              <Typography
                variant="body2"
                className={clsx(modalClasses.stateDescription)}
              >
                {stateValue.desc}
              </Typography>
            </div>
          )
        })}
        <div>
          <Typography
            component="div"
            variant="h3"
            className={clsx(modalClasses.stateRefusedTitle)}
          >
            <CMSText
              data={takeBackData?.refusedcondition}
              defaultText={t('texts:takeBack:refused_state')}
            />
          </Typography>
          <Typography
            component="div"
            variant="body2"
            className={clsx(modalClasses.stateRefusedDescription)}
          >
            <CMSText
              data={takeBackData?.refusedconditiondefinition}
              defaultText={t('texts:takeBack:refused_state')}
            />
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default StatesModal
